/** Slick Slider */
import "slick-carousel/slick/slick.js";
import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

/** Fancybox Jquery*/
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

import $ from "jquery";


$(document).ready(function () {
    $(".slider-for").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: ".multiple-items",
        rtl: window.currentLang === 'ar-sa',
    });
    $(".multiple-items").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: ".slider-for",
        dots: false,
        focusOnSelect: true,
        centerMode: false,
        rtl: window.currentLang === 'ar-sa',
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    });
});
